import { render, staticRenderFns } from "./AdditionalRoutersSelect.vue?vue&type=template&id=19203a14"
import script from "./AdditionalRoutersSelect.vue?vue&type=script&lang=js"
export * from "./AdditionalRoutersSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports